<div id="breadCrumbsWrapper" class="d-flex align-items-center">
  <!-- <nb-icon icon="home" id="homeIcon" (click)="redirectToHome()"></nb-icon> -->

  <div class="separator" *ngIf="pagePath?.parent">
    <nb-icon icon="arrow-ios-forward-outline"></nb-icon>
  </div>

  <div
    class="pathItem branch-selector"
    *ngIf="!pagePath?.context && pagePath?.parent !== 'Project'"
  >
    {{ pagePath?.parent }}
  </div>
  <ng-container *ngIf="breadcrumbConfig?.blueprint">
    <div
      class="pathItem"
      [ngClass]="{ 'font-weight-bold': !breadcrumbConfig?.environment }"
    >
      <a
        routerLink="/capc/home"
        nbTooltip="Change Project"
        nbTooltipPlacement="bottom"
        (click)="onClickMoveProjects()"
        >Projects</a
      >
    </div>
    <div class="separator">
      <nb-icon icon="arrow-ios-forward-outline"></nb-icon>
    </div>
    <div class="d-flex align-items-center switcherContext">
      <div class="d-flex py-1 config">
        <app-smooth-width
          [trigger]="breadcrumbConfig?.blueprint"
          class="configItem"
        >
          <ng-container>
            <div class="configItem currentBlueprint">
              <!-- <nb-icon
                [icon]="
                  blueprintTemplateMap[breadcrumbConfig.blueprint]
                    ? 'template-icon'
                    : 'layers-outline'
                "
                [pack]="
                  blueprintTemplateMap[breadcrumbConfig.blueprint]
                    ? 'fci'
                    : 'eva'
                "
                class="configIcon"
              ></nb-icon> -->
              <span class="itemName">
                {{
                  this.blueprintNameLabelService.getBlueprintsNameLabelMap()[
                    breadcrumbConfig.blueprint
                  ]
                }}
              </span>
            </div>
          </ng-container>
        </app-smooth-width>
      </div>
      <!-- <button nbButton ghost size="small" (click)="navigateToCapcHome()">
        <nb-icon icon="grid-outline" nbTooltip="Change Project"></nb-icon>
      </button> -->
    </div>
    <div
      class="branch-selector"
      *ngIf="branchSelectorNeeded && breadcrumbConfig?.branch"
    >
      <span class="mx-1 pathItem" style="font-size: smaller; color: dimgray"
        >( Branches
        <div class="separator">
          <nb-icon icon="arrow-ios-forward-outline"></nb-icon>
        </div>
      </span>
      <app-branch-selector
        [fetchingBranches]="fetchingBranches"
        [blueprintName]="breadcrumbConfig?.blueprint"
        [defaultBranch]="breadcrumbConfig?.branch?.defaultBranch"
        [selectedBranch]="breadcrumbConfig?.branch?.selectedBranch"
        [allBranches]="breadcrumbConfig?.branch?.branches"
        [contextSwitcherOpen]="contextSwitcherOpen"
        (byBranchSelectorOpen)="closeContextSwitcher()"
        (byBranchSelectionChange)="updateBranchInContext($event)"
      ></app-branch-selector>
      <span class="mx-1 pathItem" style="font-size: smaller; color: dimgray"
        >)</span
      >
    </div>
  </ng-container>

  <ng-container *ngIf="breadcrumbConfig?.environment && !contextWidgetPresent">
    <div class="separator">
      <nb-icon icon="arrow-ios-forward-outline"></nb-icon>
    </div>
    <div
      class="pathItem"
      [ngClass]="{
        'font-weight-bold':
          breadcrumbConfig?.environment && !breadcrumbConfig?.resource
      }"
    >
      <a [routerLink]="['stack/' + breadcrumbConfig?.blueprint]">
        Environments
      </a>
    </div>
    <div class="separator">
      <nb-icon icon="arrow-ios-forward-outline"></nb-icon>
    </div>
    <div
      class="d-flex align-items-center switcherContext environmentOnlyBG"
      (click)="toggleContextSwitcher($event, ENVIRONMENT)"
    >
      <div class="d-flex px-2 py-1 config" style="padding-right: 0 !important">
        <app-smooth-width
          [trigger]="breadcrumbConfig?.environment"
          class="configItem"
        >
          <ng-container *ngIf="breadcrumbConfig?.environment">
            <div
              [id]="
                dependentEnvironments?.includes(
                  breadcrumbConfig?.blueprint +
                    ':' +
                    breadcrumbConfig?.environment
                )
                  ? 'currentDependentEnvironment'
                  : 'currentEnvironment'
              "
              class="configItem"
            >
              <!-- <nb-icon
                [icon]="
                  dependentEnvironments?.includes(
                    breadcrumbConfig?.blueprint +
                      ':' +
                      breadcrumbConfig?.environment
                  )
                    ? 'two-clouds-outline'
                    : 'cloud-download-outline'
                "
                class="configIcon"
                pack="fci"
              ></nb-icon> -->
              <span class="itemName environmentOnlyColor">
                <a
                  (click)="
                    routeToLink(
                      $event,
                      '/stack' +
                        breadcrumbConfig?.blueprint +
                        'dialog' +
                        '/cluster/' +
                        breadcrumbConfig?.clusterId +
                        '/overview-v2'
                    )
                  "
                  >{{ breadcrumbConfig.environment }}</a
                >
              </span>
            </div>
          </ng-container>
        </app-smooth-width>
      </div>
      <div class="contextSwitcherIcon">
        <button
          nbButton
          ghost
          size="small"
          *ngIf="
            !contextSwitcherOpen || (!showEnvironmentCS && contextSwitcherOpen)
          "
          class="environment-switcher-icon"
        >
          <nb-icon icon="arrow-down-outline"></nb-icon>
        </button>
        <button
          nbButton
          ghost
          size="small"
          *ngIf="contextSwitcherOpen && showEnvironmentCS"
          class="environment-switcher-icon"
        >
          <nb-icon icon="arrow-up-outline"></nb-icon>
        </button>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="breadcrumbConfig?.resource && !contextWidgetPresent">
    <div class="separator">
      <nb-icon icon="arrow-ios-forward-outline"></nb-icon>
    </div>
    <div
      class="pathItem"
      [ngClass]="{ 'font-weight-bold': breadcrumbConfig?.resource }"
    >
      <a
        [routerLink]="[
          breadcrumbConfig.blueprint +
            '/cluster/' +
            environmentIDMap[
              breadcrumbConfig?.blueprint + '_' + breadcrumbConfig?.environment
            ] +
            '/resources'
        ]"
      >
        Resources
      </a>
    </div>
    <div class="separator">
      <nb-icon icon="arrow-ios-forward-outline"></nb-icon>
    </div>
    <div
      class="d-flex align-items-center switcherContext blueprintOnlyBG"
      (click)="toggleContextSwitcher($event, RESOURCE)"
    >
      <div class="d-flex px-2 py-1 config" style="padding-right: 0 !important">
        <app-smooth-width
          [trigger]="breadcrumbConfig?.resourceType"
          class="configItem"
        >
          <ng-container *ngIf="breadcrumbConfig?.resourceType">
            <div class="configItem currentResourceType">
              <!-- <nb-icon icon="layout-outline" class="configIcon"></nb-icon> -->
              <span class="itemName mr-2">
                {{ breadcrumbConfig.resourceType }}
              </span>
            </div>
          </ng-container>
        </app-smooth-width>
        <app-smooth-width
          [trigger]="breadcrumbConfig?.resource"
          class="configItem"
        >
          <ng-container *ngIf="breadcrumbConfig?.resource">
            <div class="separator">
              <nb-icon icon="arrow-ios-forward-outline"></nb-icon>
            </div>
            <div class="configItem currentResource">
              <span class="itemName">
                {{ breadcrumbConfig.resource }}
              </span>
            </div>
          </ng-container>
        </app-smooth-width>
      </div>
      <div class="contextSwitcherIcon">
        <button
          nbButton
          size="small"
          ghost
          size="small"
          *ngIf="
            !contextSwitcherOpen || (showEnvironmentCS && contextSwitcherOpen)
          "
          class="blueprint-switcher-icon"
        >
          <nb-icon icon="arrow-down-outline"></nb-icon>
        </button>
        <button
          nbButton
          ghost
          size="small"
          *ngIf="contextSwitcherOpen && !showEnvironmentCS"
          class="blueprint-switcher-icon"
        >
          <nb-icon icon="arrow-up-outline"></nb-icon>
        </button>
      </div>
    </div>
  </ng-container>

  <ng-template #brokenContext>
    <app-smooth-width [trigger]="incorrectURL" class="configItem">
      <div
        id="brokenContext"
        (click)="redirectToHandleIncorrectURL()"
        [nbTooltip]="this.incorrectURLTooltip"
        nbTooltipPlacement="bottom"
      >
        <nb-icon icon="alert-triangle-outline"></nb-icon>
        <span> broken context </span>
      </div>
    </app-smooth-width>
  </ng-template>
</div>

<ng-container #contextSwitcher *ngIf="contextSwitcherOpen">
  <div id="contextSwitcherWrapper">
    <nb-card class="mb-0">
      <nb-card-body class="d-flex">
        <div
          class="selector"
          *ngIf="breadcrumbConfig?.environment && showEnvironmentCS"
        >
          <input
            [ngModel]="undefined"
            (ngModelChange)="
              onModelChange($event, 'environment', allEnvironments, 'name')
            "
            nbInput
            type="text"
            fullWidth
            placeholder="Environment"
            #environmentSearchTerm
          />

          <div class="d-flex flex-column" id="allOptionsWrapper">
            <ng-container
              *ngIf="
                !allEnvironments || !allEnvironments?.length;
                else showEnvironments
              "
            >
              <div class="resourceError">No environments</div>
            </ng-container>
            <ng-template #showEnvironments>
              <ng-container
                *ngFor="
                  let environment of filteredNgModelOptions$['environment']
                    | async
                "
              >
                <div
                  (click)="
                    setNextBreadcrumbConfig('environment', environment?.name)
                  "
                  [ngClass]="{
                    configOption: 1,
                    activeItem:
                      environment?.name === nextBreadcrumbConfig?.environment
                  }"
                >
                  {{ environment.name }}
                </div>
              </ng-container>
            </ng-template>
          </div>
        </div>
        <div
          [ngClass]="{
            selector: 1,
            disableSelector:
              fetchingResourceTypes ||
              !this.allResourceTypes ||
              !this.allResourceTypes?.length
          }"
          *ngIf="breadcrumbConfig?.resource && !showEnvironmentCS"
        >
          <input
            [ngModel]="undefined"
            (ngModelChange)="
              onModelChange($event, 'resourceType', allResourceTypes)
            "
            nbInput
            type="text"
            fullWidth
            placeholder="Resource Type"
            #resourceTypeSearchTerm
          />

          <div class="d-flex flex-column" id="allOptionsWrapper">
            <ng-container *ngIf="fetchingResourceTypes; else noFetchRT">
              <nb-card
                [nbSpinner]="true"
                nbSpinnerStatus="basic"
                class="spinnerContainer"
              >
                <nb-card-body> </nb-card-body>
              </nb-card>
            </ng-container>
            <ng-template #noFetchRT>
              <ng-container *ngIf="noResourcesError; else showResourceTypes">
                <div class="resourceError">Nothing available</div>
              </ng-container>
              <ng-template #showResourceTypes>
                <ng-container
                  *ngFor="
                    let resourceType of filteredNgModelOptions$['resourceType']
                      | async
                  "
                >
                  <div
                    (click)="
                      setNextBreadcrumbConfig('resourceType', resourceType)
                    "
                    [ngClass]="{
                      configOption: 1,
                      activeItem:
                        resourceType === nextBreadcrumbConfig?.resourceType
                    }"
                  >
                    {{ resourceType }}
                  </div>
                </ng-container>
              </ng-template>
            </ng-template>
          </div>
        </div>
        <div
          [ngClass]="{
            selector: 1,
            disableSelector:
              fetchingResourceTypes ||
              !this.allResourceTypes ||
              !this.allResourceTypes?.length
          }"
          *ngIf="breadcrumbConfig?.resource && !showEnvironmentCS"
        >
          <input
            [ngModel]="undefined"
            (ngModelChange)="onModelChange($event, 'resource', allResources)"
            nbInput
            type="text"
            fullWidth
            placeholder="Resource"
            #resourceSearchTerm
          />

          <div class="d-flex flex-column" id="allOptionsWrapper">
            <ng-container *ngIf="fetchingResourceTypes; else noFetchR">
              <nb-card
                [nbSpinner]="true"
                nbSpinnerStatus="basic"
                class="spinnerContainer"
              >
                <nb-card-body> </nb-card-body>
              </nb-card>
            </ng-container>
            <ng-template #noFetchR>
              <ng-container *ngIf="noResourcesError; else showResources">
                <div class="resourceError">Nothing available</div>
              </ng-container>
              <ng-template #showResources>
                <ng-container
                  *ngFor="
                    let resource of filteredNgModelOptions$['resource'] | async
                  "
                >
                  <div
                    (click)="setNextBreadcrumbConfig('resource', resource)"
                    [ngClass]="{
                      configOption: 1,
                      activeItem: resource === nextBreadcrumbConfig?.resource
                    }"
                  >
                    {{ resource }}
                  </div>
                </ng-container>
              </ng-template>
            </ng-template>
          </div>
        </div>
      </nb-card-body>
      <nb-card-footer class="d-flex justify-content-end pt-0">
        <button
          nbButton
          size="small"
          class="mr-3"
          (click)="cancelContextSwitch()"
        >
          Cancel
        </button>
        <button
          nbButton
          size="small"
          status="primary"
          (click)="applyBreadcrumbConfig()"
          [disabled]="!isValidBreadcrumb"
        >
          Apply
        </button>
      </nb-card-footer>
    </nb-card>
  </div>
</ng-container>
